module.exports = __webpack_public_path__ + "img/public/SiteIcons/expandIcon.svg?668d2eee";